import toArray = require('lodash/toArray');
import $ from './gs-zepto';
import blazy from './blazy';

class GridstrapComponents {
	private registry: Map<String,Object>;
	private mutationObserver: MutationObserver;
	private directory: Array<any>;

	constructor() {
		this.registry = new Map();
		this.directory = new Array();
		this.mutationObserver = new MutationObserver(mutations => this.processMutations(mutations));
		this.mutationObserver.observe(document.body, { childList: true, subtree: true });
	}

	register({selector, controller}) {
		for (let node of $(selector)) {
			this.attachController(node, controller);
		}
		this.registry.set(selector, controller);
	}

	getControllers(nodes) {
		return nodes.map(node => this.getController(node));
	}

	getController(node) {
		let pos = $(node).data('gsc');
		return this.directory[pos];
	}

	// Mutation processing

	private processMutations(mutations: MutationRecord[]) {
		for (const mutation of mutations) {
			if (mutation.type == "childList") {
				this.processRemovedNodes(mutation.removedNodes);
				this.processAddedNodes(mutation.addedNodes);
			}
		}
	}

	private processRemovedNodes(nodes: NodeList) {
		for (const node of toArray(nodes)) {
			this.scanForOldComponents(node);
		}
	}

	private processAddedNodes(nodes: NodeList) {
		for (const node of toArray(nodes)) {
			this.scanForNewComponents(node);
		}

		if (nodes.length > 0) {
			setTimeout(() => blazy.revalidate(), 100);
		}
	}

	// Component Controller Attachment

	private scanForNewComponents(node) {
		for (const item of toArray(this.registry)) {
			this.detectNewComponent(node, item[0], item[1]);
		}
		this.findAll(node, '.gsc-init').removeClass('gsc-init').gs('gsOnInit');
		this.findAll(node, '.gsc-resize').gs('gsOnWindowResize');
		this.findAll(node, '.gsc-scroll').gs('gsOnPageScroll');
	}

	private detectNewComponent(node, selector, controller) {
		let allNodes = this.findAll(node, selector);
		for (const match of allNodes) {
			this.attachController(match, controller);
		}
	}

	private attachController(node, controller) {
		let component = new controller(node);
		$(node).data('gsc', this.directory.length)
			.toggleClass('gsc-resize',  !!component.gsOnWindowResize)
			.toggleClass('gsc-scroll',  !!component.gsOnPageScroll)
			.toggleClass('gsc-unload',  !!component.gsOnPageUnload)
			.toggleClass('gsc-init',    !!component.gsOnInit)
			.toggleClass('gsc-data',    !!component.gsOnDataReady)
			.toggleClass('gsc-destroy', !!component.gsOnDestroy)
			.addClass('gsc');
		this.directory.push(component);
	}

	// Component Controller Detachment

	private scanForOldComponents(node) {
		const matches = this.findAll(node, '.gsc');
		for (const match of matches) {
			this.detachController(match);
		}
	}

	private detachController(node) {
		const controller: any = this.getController(node);
		if (controller && controller.gsOnDestroy) controller.gsOnDestroy();
		let pos = $(node).data('gsc');
		this.directory[pos] = null;
	}

	// Utilities

	private findAll(node, selector) {
		const base = $(node);
		return base.find(selector).add(base.filter(selector));
	}
}

export const components = new GridstrapComponents();
